<template>
  <div>
    <a-modal v-model="visible" :confirmLoading="loading" :maskClosable="false" width="720px" @cancel="cancel" @ok="confirm">
      <div slot="title">{{ form.id ? '编辑药剂' : '新增药剂' }}</div>
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-row>
          <a-col :span="12">
            <a-form-model-item prop="name" label="商品名称">
              <a-input v-model="form.name" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item prop="common_name" label="通用名">
              <a-input v-model="form.common_name" allowClear />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item prop="crop" label="适用作物">
              <a-select v-model="form.crop" style="width: 100%">
                <a-select-option v-for="o in cropOptions" :key="o.value" :value="o.value">{{ o.label }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item prop="category" label="药剂类型">
              <a-select v-model="form.category" style="width: 100%">
                <a-select-option v-for="o in categoryOptions" :key="o.value" :value="o.value">{{ o.label }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item prop="growth_stages" label="适用生育期" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
              <a-select v-model="form.growth_stages" mode="multiple" style="width: 100%" placeholder="可多选">
                <a-select-option v-for="o in stageOptions" :key="o.value" :value="o.value">{{ o.label }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item prop="active_ingredient" label="有效成分及含量">
              <a-input v-model="form.active_ingredient" placeholder="如：吡虫啉 10%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item prop="formulation" label="剂型">
              <a-input v-model="form.formulation" placeholder="乳油/悬浮剂/可湿性粉剂" allowClear />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item prop="effect_tags" label="功效特点" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
              <a-select
                v-model="form.effect_tags"
                mode="tags"
                style="width: 100%"
                placeholder="如：杀卵、杀小龄虫、除小草"
                :tokenSeparators="[',']"
              >
                <a-select-option v-for="t in tagSuggestions" :key="t" :value="t">{{ t }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item prop="target" label="防治对象" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
              <a-input v-model="form.target" allowClear />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item prop="dosage" label="推荐用量">
              <a-input v-model="form.dosage" allowClear />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item prop="method" label="施用方法">
              <a-input v-model="form.method" allowClear />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item prop="safety_interval" label="安全间隔期(天)">
              <a-input-number v-model="form.safety_interval" :min="0" style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item prop="is_active" label="启用">
              <a-switch v-model="form.is_active" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item prop="usage_guide" label="使用说明" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
              <a-textarea v-model="form.usage_guide" :rows="3" allowClear />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item prop="precautions" label="注意事项" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
              <a-textarea v-model="form.precautions" :rows="2" allowClear />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item prop="remark" label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
              <a-input v-model="form.remark" allowClear />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { pesticideCreate, pesticideUpdate } from '@/api/plantProtect'

export default {
  name: 'FormModal',
  props: ['visible', 'form', 'cropOptions', 'categoryOptions', 'stageOptions', 'tagSuggestions'],
  model: { prop: 'visible', event: 'cancel' },
  data() {
    return {
      rules: {
        name: [{ required: true, message: '请输入商品名称', trigger: 'change' }],
        crop: [{ required: true, message: '请选择作物', trigger: 'change' }],
        category: [{ required: true, message: '请选择类型', trigger: 'change' }],
        active_ingredient: [{ required: true, message: '请输入有效成分及含量', trigger: 'change' }],
      },
      loading: false,
    }
  },
  watch: {
    visible(val) {
      if (val && !this.form.id) {
        this.$set(this.form, 'crop', this.form.crop || 'both')
        this.$set(this.form, 'is_active', this.form.is_active !== false)
        this.$set(this.form, 'growth_stages', this.form.growth_stages || [])
        this.$set(this.form, 'effect_tags', this.form.effect_tags || [])
      }
    },
  },
  methods: {
    confirm() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.loading = true
        const func = this.form.id ? pesticideUpdate : pesticideCreate
        func(this.form).then(data => {
          this.$message.success(this.form.id ? '修改成功' : '新增成功')
          this.$emit(this.form.id ? 'update' : 'create', data)
          this.cancel()
        }).finally(() => {
          this.loading = false
        })
      })
    },
    cancel() {
      this.$emit('cancel', false)
      this.$refs.form && this.$refs.form.resetFields()
    },
  },
}
</script>
